import { ContentRow } from "store/contentInterfaces";

export default (row: ContentRow): ContentRow => ({
  ...row,
  status: row.status === "DRAFT" ? "DRAFT" : "CHANGED",
});
